/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { guestAddressSchema } from "./guestAddressSchema.ts";

export const deliveryAddressesListStatus200Schema = z.array(guestAddressSchema);

export const deliveryAddressesListResponseSchema = deliveryAddressesListStatus200Schema;
